import type { AssetType } from '@/types/assets';

// Map old fund type values to new AssetType values
export const mapFundTypeToAssetType = (fundType?: string): AssetType => {
  if (!fundType) return 'equity';

  switch (fundType) {
    case 'stocks':
      return 'equity';
    case 'bonds':
      return 'fixed_income';
    case 'cash':
      return 'cash';
    case 'alternative':
      return 'alternative';
    case 'all':
      return 'multi_asset'; // Multi-Asset section returns 'all'
    default:
      return 'equity';
  }
};
